import React from "react";
import Icon from "./icon";

function PlaceholderIcon(props) {
  return (
    <Icon viewBox="0 0 299.995 299.995" {...props}>
      <g>
        <g>
          <path d="M78.841,216.367c0,4.186,3.408,7.594,7.597,7.594H213.56c4.189,0,7.597-3.405,7.597-7.594v-85.456H78.841V216.367z" />
          <path d="M221.154,98.03c0.002-4.186-3.406-7.594-7.594-7.594H86.438c-4.189,0-7.597,3.405-7.597,7.594v17.32h142.313V98.03z
				 M102.017,109.281h-9.736V98.906h9.736V109.281z M119.687,109.281h-9.736V98.906h9.736V109.281z M137.355,109.281h-9.736V98.906
				h9.736V109.281z"/>
          <path d="M149.996,0C67.157,0,0.001,67.161,0.001,149.997S67.157,300,149.996,300s150.003-67.163,150.003-150.003
				S232.835,0,149.996,0z M236.718,216.367c0,12.768-10.39,23.156-23.158,23.156H86.438c-12.768,0-23.158-10.387-23.158-23.156
				V98.03c0-12.768,10.387-23.156,23.158-23.156H213.56c12.768,0,23.158,10.387,23.158,23.156V216.367z"/>
        </g>
      </g>
    </Icon>
  );
}
export default PlaceholderIcon;
